import { getCuratedCratesQueryOptions } from "@/features/garimpos/garimpos-query";
import { getStoresQueryOptions } from "@/routes/_pages/$lang/stores/stores-query";
const SplitLoader = async ({
  context: {
    queryClient,
    locale,
    viewer
  }
}) => {
  const [curated] = await Promise.all([queryClient.ensureQueryData(getCuratedCratesQueryOptions({
    currency: viewer.preferences.currency
  })).catch(() => null), queryClient.ensureQueryData(getStoresQueryOptions()).catch(() => null)]);
  return {
    locale,
    crateIds: curated?.crates.map(crate => crate.id) ?? []
  };
};
export { SplitLoader as loader };